export default __webpack_public_path__ + "static/media/logo_horizontal.6641c9bf.png";